module.exports = __webpack_public_path__ + "static/media/hero.009b18cc.jpg";